import React, { useState, useEffect } from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

export default function ScrollButton() {
    const [atTop, setAtTop] = useState(true); // true = show "bottom" button

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.pageYOffset;
            const windowHeight = window.innerHeight;
            const fullHeight = document.body.scrollHeight;

            if (scrollPosition + windowHeight >= fullHeight - 10) {
                setAtTop(false); // Near bottom → show "top" button
            } else if (scrollPosition <= 10) {
                setAtTop(true); // Near top → show "bottom" button
            } else {
                setAtTop(false); // In middle → show "top" button
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const scrollToBottom = () => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    };

    return (
        <div>
            {atTop ? (
                <button onClick={scrollToBottom} className="btn-scroll">
                    <ArrowDown size={24} />
                </button>
            ) : (
                <button onClick={scrollToTop} className="btn-scroll">
                    <ArrowUp size={24} />
                </button>
            )}
        </div>
    );
}
